import { FETCH_CATEGORY_SUCCESS } from "./actionType";
import swal from 'sweetalert'

export const categoryFetchSuccess = function (payload) {
  return {
    type: FETCH_CATEGORY_SUCCESS,
    payload,
  };
};

export const fetchCategories = function () {
  return (dispatch) => {
    fetch("https://why-florist.herokuapp.com/categories")
    .then((response) => {
      if (!response.ok) {
        swal("Error", response.statusText, "error")
      }
      return response.json();
    })
      .then((data) => dispatch(categoryFetchSuccess(data)));
  };
};
